// UI imports
import "./SubscriptionProfile.scss";
import * as React from "react";
import PublicPageLayout from "../../../layout/publicPageLayout/PublicPageLayout";
import {Card, CardBody, CardHeader, CardSubtitle, CardTitle, GridLayout, GridLayoutItem,} from "@progress/kendo-react-layout";
import {Form, Field, FormElement, FormRenderProps,} from "@progress/kendo-react-form";
import {Input} from "@progress/kendo-react-inputs";
import Checkbox from "../../../components/stateless/checkbox/Checkbox";
import {confirmPasswordValidator, passwordValidator} from "../authentication/helpers/Validators";
import {useEffect, useState} from "react";
import Table from "../../../components/stateful/table/Table";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {
  deleteAllUserSubscription,
  deleteUserSubscription,
  getUserSubscriptionByEmail,
} from "../../../features/public/publicUserSubscription-slice";
import {GenerateUserSubscriptionColumnDefinition} from "../../../components/stateful/table/TableHelper";
import {UserSubscription} from "../../../utilities/interfaces/UserSubscription";
import {subscriptionUserAPI} from "../../../utilities/api";
import PasswordForm from "../authentication/helpers/PasswordForm";
import {Popup} from "@progress/kendo-react-popup";


function SubscriptionProfilePage() {
  const [editMode, setEditMode] = React.useState<boolean>(false);
  const [changePassCheck, setChangePassCheck] = React.useState<boolean>(false);
  const [columnData, setColumnData] = useState<any>(null);
  const [showUnsubscribeConfirmation, setShowUnsubscribeConfirmation] = React.useState(false);
  const [passwordError, setPasswordError] = React.useState("");
  const [passwordConfirmation, setPasswordConfirmation] = React.useState("");
  const [tableDataLoaded, setTableDataLoaded] = React.useState(false);
  const [userSubscriptionTable, setUserSubscriptionTable] = React.useState<any>();

  const emailAddress = localStorage.getItem("subscriptionUser") ?? "";
  const userSubscription: UserSubscription[] = useAppSelector((state) => state.publicUserSubscription.userSubscription);

  const togglePassCheck = () => {setChangePassCheck(!changePassCheck);};
  const toggleEdit = () => {editMode ? setEditMode(false) : setEditMode(true);};
  const anchor = React.useRef<HTMLButtonElement | null>(null);
  const dispatch = useAppDispatch();

  // the dependencies are left blank on purpose so the acts as onMount()
  useEffect(() => {
    const runningInEffect = async () => {
      if (userSubscription.length < 1) {
        await dispatch(getUserSubscriptionByEmail(emailAddress));
      }else{
        formatTableData();
      }

      await getTableDefinitions();
    };

    runningInEffect().catch(x => console.log(x));
  }, [dispatch, emailAddress, userSubscription.length]);


  const getTableDefinitions = async () => {
    let columns = GenerateUserSubscriptionColumnDefinition();
    setColumnData(columns);
  };

  const formatTableData = () => {

    let tableData: any[] = [];

    userSubscription.forEach( (subscription) => {

      let row = {
        ...subscription,
        agencyRow: subscription.agencyId ? ((subscription.agencyId ?? "") + " " + (subscription.agencyName ?? "")) : "",
        titleRow: subscription.titleId ? ((subscription.titleId ?? "") + " " + (subscription.titleName ?? "")) : "",
        chapterRow: subscription.chapterId ? ((subscription.chapterId ?? "") + " " + (subscription.chapterName ?? "")) : "",
      };

      tableData.push(row);
    });

    setUserSubscriptionTable(tableData);
    setTableDataLoaded(true);
  }

  const unsubscribe = (dataItem: any) => {
    dispatch(deleteUserSubscription(dataItem));
  };

  const unsubscribeAll = () => {
    setShowUnsubscribeConfirmation(!showUnsubscribeConfirmation);
  }

  const cancelUnsubscribe = () => {
    setShowUnsubscribeConfirmation(false);
  }

  const confirmUnsubscribeAll = () => {
    dispatch(deleteAllUserSubscription(userSubscription));
    setShowUnsubscribeConfirmation(!showUnsubscribeConfirmation);
  }

  const submitPasswordChange = async (dataItem: { [name: string]: any }) => {

    const subscriptionEmail = localStorage.getItem("subscriptionEmail") ?? "";

    setPasswordError("");
    setPasswordConfirmation("");

    await subscriptionUserAPI.changePassword(subscriptionEmail, dataItem.old_password, dataItem.new_password)
        .then( () => {
          setPasswordConfirmation("Password Change was Successful");
          togglePassCheck();
        }).catch( (error) => {
          setPasswordError(error.response.data.message);
        });
  }

  useEffect(() => {}, [emailAddress]);

  return (

      <PublicPageLayout>
        <div className="chapters-results">

          <div className="body rule-management">
            <GridLayout rows={[{height: 100}, {height: "100%"}]} cols={[{width: "20%"}, {width: "80%"},]} gap={{rows: 5, cols: 10}}>
              <GridLayoutItem row={1} col={1} colSpan={3} className={"subscriptions-heading"}>
                <Card style={{boxShadow: "0 0 4px 0 rgba(0, 0, 0, .1)", marginTop: "15px",}}>
                  <CardHeader style={{background: "transparent",}}>
                    <CardTitle>
                      <h2>Subscriptions User Profile</h2>
                    </CardTitle>
                  </CardHeader>
                </Card>
              </GridLayoutItem>

              <GridLayoutItem row={2} col={1}>
                <Card className="card-container">
                  <CardBody>
                    <CardTitle style={{textAlign: "center", color: "#3271E7"}}>
                      Edit User Profile
                    </CardTitle>
                    <Form
                        onSubmit={submitPasswordChange}
                        render={(formRenderProps: FormRenderProps) => (
                            <FormElement style={{maxWidth: 650}}>
                              <fieldset className={"k-form-fieldset"}>
                                <div className="mb-3">
                                  {/*TODO changing the email address is not required so making it a static form component*/}
                                  {/*<Field value={EmailInput} name={"email"} type={"email"} component={EmailInput}*/}
                                  {/*       label={"Email"} validator={emailValidator} disabled={!editMode}/>*/}
                                  <p>Email Address:</p>
                                  <p>{emailAddress}</p>
                                  <p style={{color: "red"}}>{passwordError}</p>
                                  <p style={{color: "green"}}>{passwordConfirmation}</p>

                                  {editMode ? (
                                      <div style={{marginTop: "2em"}}>
                                        <Checkbox label={"Change Password?"} onClick={togglePassCheck}/>
                                        {changePassCheck ? (
                                            <Card style={{marginTop: "1em"}}>
                                              <CardSubtitle style={{textAlign: "left", border: "none",}}>
                                                <PasswordForm/>
                                              </CardSubtitle>
                                              <CardBody style={{background: "#3271E7"}}>
                                                <Field key={"old_password"} name={"old_password"} label={"Old Password"}
                                                       type={"password"} component={Input} validator={confirmPasswordValidator}/>
                                                <Field key={"new_password"} name={"new_password"} label={"New Password"}
                                                       type={"password"} component={Input} validator={passwordValidator}/>
                                              </CardBody>
                                            </Card>)
                                            : (<div></div>)}
                                      </div>)
                                      : (<div></div>)}
                                </div>
                              </fieldset>

                              {editMode ? (
                                  <div className="k-form-buttons">
                                    <button style={{width: "50%", color: "green"}} type={"submit"}
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            disabled={!formRenderProps.allowSubmit}>
                                      Submit
                                    </button>
                                    <button style={{width: "50%", color: "red"}} type={"submit"}
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={toggleEdit}>
                                      Cancel
                                    </button>
                                  </div>
                              ) : (
                                  <button type={"submit"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                          onClick={toggleEdit} style={{width: "100%", backgroundColor: "lightyellow",}}>
                                    Edit Profile
                                  </button>
                              )}
                            </FormElement>
                        )}
                    />
                  </CardBody>
                </Card>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <Card className="card-container">
                  <CardBody>
                    <CardTitle style={{textAlign: "center", color: "#3271E7",}}>
                      Manage Your Subscriptions
                      <button ref={anchor} onClick={unsubscribeAll} className="unsubscribe-button">
                        Unsubscribe All
                      </button>
                      <Popup anchor={anchor.current} show={showUnsubscribeConfirmation} popupClass={"popup-content"}>
                        <div style={{margin: "5px 15px 5px 15px"}}>
                          Do you wish to continue Unsubscribing
                          <div>
                            <button className="confirmation-button" style={{backgroundColor: "#DC3445"}} onClick={confirmUnsubscribeAll}>
                              Confirm
                            </button>
                            <button className="confirmation-button" onClick={cancelUnsubscribe}>Cancel</button>
                          </div>
                        </div>
                      </Popup>
                    </CardTitle>
                    {emailAddress && tableDataLoaded ?
                        <Table 
                          values={userSubscriptionTable}
                          columns={columnData} 
                          tableName="" 
                          height="90vh" 
                          notFilterable={true} 
                          onButtonClick={unsubscribe}
                          buttonText="Unsubscribe"  
                        />
                        : ""}
                  </CardBody>
                </Card>
              </GridLayoutItem>
            </GridLayout>
          </div>

        </div>
      </PublicPageLayout>
  );
}

export default SubscriptionProfilePage;
